import Store from "./Store";
import AppStore from "./AppStore";
import { makeObservable, runInAction, toJS } from "mobx";
import ScorecardBatch, { IScorecardBatch } from "../models/ScorecardBatch";

const parseYears = (desc: string) => {
  const match = desc?.trim().match(/^(\d{4})\s*-\s*(\d{4})$/);
  return match
    ? [parseInt(match[1], 10), parseInt(match[2], 10)]
    : [undefined, undefined];
};

export default class ScorecardStore extends Store<
  IScorecardBatch,
  ScorecardBatch
> {
  current: IScorecardBatch | null = null; //test dublicate
  active: IScorecardBatch | null = null;
  loading: boolean = true; // Might rmeove it.
  items = new Map<string, ScorecardBatch>();

  constructor(store: AppStore) {
    super(store);
    this.store = store;

    makeObservable(this, {
      current: true, //test duplicate
      active: true,
      loading: true, // might remove it
    });
  }

  get all() {
    return Array.from(toJS(this.items.values())).sort((a, b) => {
      const [a1, a2] = parseYears(a.asJson.description);
      const [b1, b2] = parseYears(b.asJson.description);

      if (a1 && b1) return b1 - a1;
      else if (a2 && b2) return b2 - a2;
      else return b.asJson.description.localeCompare(a.asJson.description);
    });
  }

  // get current scorecard id
  get currentId() {
    return this.current ? this.current.id : null;
  }
  // set current scorecard id
  setCurrent(item: IScorecardBatch) {
    runInAction(() => {
      this.current = item;
    });
  }
  clearCurrent() {
    runInAction(() => {
      this.current = null;
    });
  }

  // get active scorecard id
  get activeId() {
    return this.active ? this.active.id : null;
  }

  setActive(item: IScorecardBatch) {
    runInAction(() => {
      this.active = item;
    });
  }

  clearActive() {
    runInAction(() => {
      this.active = null;
    });
  }

  setLoading(loading: boolean) {
    runInAction(() => {
      this.loading = loading;
    });
  }

  load(items: IScorecardBatch[] = []) {
    runInAction(() => {
      items.forEach((item) =>
        this.items.set(item.id, new ScorecardBatch(this.store, item))
      );
    });
  }
}